import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MakeProvider } from '@anecdotes/design-system/form-controls';
import { DropdownControlComponent } from '../dropdown-control/dropdown-control.component';
import { MenuAction } from '../../types';

@Component({
  selector: 'app-colored-dropdown-control',
  templateUrl: './colored-dropdown-control.component.html',
  providers: [MakeProvider(ColoredDropdownControlComponent)],
  standalone: false,
})
export class ColoredDropdownControlComponent extends DropdownControlComponent implements OnInit {
  @Input()
  buttonBackgroundClass: string;

  @Input()
  textClasses: string;

  @Input()
  hasTooltip = true;

  @Input()
  tooltip: string | TemplateRef<any>;

  @Input()
  tooltipPlacement = 'top';

  @Input()
  radius: 'small' | 'large' = 'small';

  @Input()
  isReadOnly = false;

  @Input()
  noValueTextTranslationKey: string;

  @Input()
  verticalSize: 'small' | 'medium' = 'medium';

  @Input()
  arrowEnabled: boolean;

  @Input()
  arrowBlackColor: boolean;

  @Input()
  displayEmptyState = true;

  @Input()
  clearEnabled: boolean;

  @Input()
  clearOptionCustomText: string;

  @Output()
  clearSelection = new EventEmitter<string>();

  @Input()
  valueTemplate: any;

  @Input()
  numerateOptions = false;

  @Input()
  customOptions: MenuAction[] = [];

  @Input()
  isMixed: boolean;

  @Input()
  mixedButtonTranslationKey: string;

  @Input()
  mixedLabelTranslationKey: string;

  @Input()
  customButton: TemplateRef<any>;

  @Input()
  listMinWidthClass: string;

  @Input()
  buttonIcon: string;

  @Input()
  iconClasses = 'mr-1.5 h-3';

  @Input()
  mixedButtonIcon: string;

  @Input()
  label: string;

  @Input()
  required: boolean;

  @Input()
  useInlineWidth = false;

  get listWidth(): number {
    if (!this.isDropdownOpened) {
      return 0;
    }

    switch (true) {
      case (this.customListWidth === 'fit-dropdown-button'):
        return this.hostElementRef.nativeElement.getBoundingClientRect().width;
      case (this.customListWidth === 'double-dropdown-button'):
        return this.hostElementRef.nativeElement.getBoundingClientRect().width * 2;
      case (typeof this.customListWidth === 'number'):
        return this.customListWidth as number;
      default:
        return;
    }
  }

  get dropdownClasses(): string {
    return this.useInlineWidth
      ? ''
      : `${this.listMinWidthClass || 'min-w-36'} max-w-50`;
  }

  constructor(
    injector: Injector,
    translate: TranslateService,
    hostElementRef: ElementRef<HTMLElement>,
    cd: ChangeDetectorRef,
  ) {
    super(injector, translate, hostElementRef, cd);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  clearClick(): void {
    this.close();
    this.clearSelection.emit();
  }
}
